import { render, staticRenderFns } from "./EducationStudentDocumentPreview.vue?vue&type=template&id=2587880c&scoped=true"
import script from "./EducationStudentDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./EducationStudentDocumentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587880c",
  null
  
)

export default component.exports